import {
    companyNavBarSection,
    contactsNavBarSection,
    findCompaniesContactsNavBarSection,
    listsNavBarSection,
    salesAdIntelligenceNavBarSection,
    salesHomeNavBarItem,
    searchAppsNavBarSection,
    toolsAndManagementNavBarSection,
} from "app/components/sidebar3/dynamic-config/configs/sidebar31/list-items/salesListItems";
import { premiumFeatures, upsellFeatures, userSettings, whatsNew } from "app/components/sidebar3/SideBarItems";
import type { IPrimarySidebarItem } from "app/components/sidebar3/types";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

export const getSalesItemsList = (): IPrimarySidebarItem[] => {
    if (salesSettingsHelper.isAppsOnly) {
        return [searchAppsNavBarSection, userSettings];
    }

    return [
        salesHomeNavBarItem,
        findCompaniesContactsNavBarSection,
        contactsNavBarSection,
        companyNavBarSection,
        listsNavBarSection,
        salesAdIntelligenceNavBarSection,
        toolsAndManagementNavBarSection,

        upsellFeatures,
        premiumFeatures,
        whatsNew,
        userSettings,
    ];
};
